import { formatUrl } from "@config/utils";

export default {
    mixins: [
    ],
    data() {
        return {
            appCode: null,
        }
    },
    mounted() {
        this.setApplicationCode(this.$route?.params?.appCode);
    },
    computed: {
        applicationCode() {
            return this.$store.getters.applicationCode;
        },
    },
    methods: {
        setApplicationCode(appCode) {
            if(appCode) {
                this.$store.dispatch('setApplicationCode', appCode);
            }
        },
        prepareUrl: function(url) {
            return url ? formatUrl(url, {applicationCode: this.applicationCode}) : null;
        },
    },
};
